var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ol",
      { staticClass: "items-list row" },
      _vm._l(_vm.items, function (item, index) {
        return _c("li", { key: "item" + index, staticClass: "col-12" }, [
          _c("div", { staticClass: "items-list-item" }, [
            _c("span", {
              staticClass: "item-icon ob1-item-step",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item-container",
                class: _vm.noBorderBottom ? "no-border-bottom" : "",
              },
              [
                _c("div", { staticClass: "item-text" }, [
                  _c("span", { domProps: { innerHTML: _vm._s(item.label) } }),
                  _vm._v(" "),
                  item.description
                    ? _c("small", {
                        staticClass: "item-desc",
                        domProps: { innerHTML: _vm._s(item.description) },
                      })
                    : _vm._e(),
                ]),
              ]
            ),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }